import TextTooltip from 'components/molecules/TextToolTip'
import { useEffect, useRef, useState } from 'react'
import { SummaryCard } from './styles'
import { Question } from '../../constants'

export interface SectionGroupSummaryProps {
  Description: string
  FirmId: number
  IsDisabled: boolean
  Name: string
  Order: number
  QuestionGroupId: number
  QuestionSectionId: number
  GroupSummary: string
  QuestionTypeId: number
  QuestionVersionId: number
  Value: string
  Questions: Question[]
  handleClick: (questionId: number) => void
}

const QuestionnaireSectionGroupSummaryCard = (
  props: SectionGroupSummaryProps
): JSX.Element => {
  const { Name, QuestionGroupId, handleClick, GroupSummary, Questions } = props

  const [isGroupCompleted, setIsGroupCompleted] = useState(false)
  const enabledQuestionsRef = useRef(0)

  useEffect(() => {
    if (Questions && Questions.length) {
      const foundNotCompletedQuestion = Questions.find((Question) => {
        return Question.UnitForm.QuestionCompleteFlag === false
      })

      foundNotCompletedQuestion &&
      Object.keys(foundNotCompletedQuestion).length !== 0
        ? setIsGroupCompleted(false)
        : setIsGroupCompleted(true)
    }
  })

  useEffect(() => {
    enabledQuestionsRef.current = (
      Questions.filter((question) => {
        return !question.IsDisabled
      }) || []
    ).length
  }, [])

  return (
    <>
      {enabledQuestionsRef.current ? (
        <SummaryCard>
          <div
            className='summary-card'
            onClick={() => handleClick(QuestionGroupId)}
            style={{ cursor: 'pointer' }}
          >
            {isGroupCompleted ? (
              <div className='mdi mdi-checkbox-multiple-marked-circle-outline complete' />
            ) : (
              <div className='mdi mdi-checkbox-multiple-marked-circle-outline' />
            )}
            <div className='question-description'>
              <div className='question-name' data-testid='question-name'>
                {Name}
              </div>
              <TextTooltip text={GroupSummary}></TextTooltip>
            </div>

            <div className='mdi mdi-chevron-right' data-tesid='chevron-right' />
          </div>
        </SummaryCard>
      ) : (
        <></>
      )}
    </>
  )
}

export default QuestionnaireSectionGroupSummaryCard
